import React, { useEffect, useState } from "react";
import { QRCodeSVG as QRCode } from "qrcode.react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";
import { X } from "lucide-react";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const [qrCode, setQrCode] = useState("");

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;
      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) { toastError(err); }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const socket = openSocket();

    const handleWhatsAppSession = (data) => {
      if (data.action === "update" && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);
        // Only auto-close when the session actually connected — not on auth_failure or disconnect
        if (data.session.status === "CONNECTED") onClose();
      }
    };

    socket.on("whatsappSession", handleWhatsAppSession);

    return () => {
      socket.off("whatsappSession", handleWhatsAppSession);
    };
  }, [whatsAppId, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white dark:bg-slate-900 rounded-xl shadow-xl border border-slate-200 dark:border-slate-700 p-6 flex flex-col items-center gap-4">
        <div className="flex items-center justify-between w-full">
          <h2 className="text-base font-semibold text-indigo-600 dark:text-indigo-400">{i18n.t("qrCode.message")}</h2>
          <button onClick={onClose} className="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        {qrCode ? (
          <div className="p-4 bg-white rounded-xl shadow-sm border border-slate-200">
            <QRCode value={qrCode} size={256} />
          </div>
        ) : (
          <div className="flex items-center justify-center w-64 h-64 bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700">
            <div className="w-6 h-6 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(QrcodeModal);
